import React from "react";
import { Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import AudienceSelector from "../AudienceSelector/AudienceSelector";
import { AudienceOption } from "../../TriggerForm.types";

interface AssignedAudienceFieldsProps {
  audiences: AudienceOption[];
  handleAudienceSearch: (searchText: string) => void;
  loadMoreAudiences: () => void;
  isLoadingMore: boolean;
  hasMoreResults: boolean;
  isLoading: boolean;
  isTinyEmail: boolean;
}

const AssignedAudienceFields: React.FC<AssignedAudienceFieldsProps> = ({
  audiences,
  handleAudienceSearch,
  loadMoreAudiences,
  isLoadingMore,
  hasMoreResults,
  isLoading,
  isTinyEmail,
}) => {
  const { control } = useFormContext();

  return (
    <Grid item xs={12}>
      <Controller
        name="audiences"
        control={control}
        render={({ field: { onChange, value } }) => (
          <AudienceSelector
            value={value || []}
            onChange={onChange}
            options={audiences}
            onInputChange={handleAudienceSearch}
            isLoading={isLoadingMore || isLoading}
            hasMore={hasMoreResults}
            onScrollEnd={loadMoreAudiences}
            placeholder="Search Audience"
            label="Audience"
            enableInfiniteScroll={isTinyEmail}
          />
        )}
      />
    </Grid>
  );
};

export default AssignedAudienceFields;
